import React from "react";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";

interface SuccessMessageProps {
  onStartNewForm: () => void;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({ onStartNewForm }) => {
  return (
    <Container>
      <Row className="justify-content-center">
        <Col lg={8} md={10}>
          <Card className="text-center">
            <CardBody className="p-5">
              <div className="mb-4">
                <div className="avatar-lg mx-auto mb-4">
                  <div className="avatar-title bg-success-subtle text-success rounded-circle fs-2">
                    <i className="ri-checkbox-circle-fill"></i>
                  </div>
                </div>
                <h4 className="text-success mb-3">
                  Request Submitted Successfully!
                </h4>
                <p className="text-muted mb-4">
                  Your government request has been successfully submitted and
                  will be reviewed by the Risk Management Unit. We thank you for
                  your prompt action and valued participation in this process.
                </p>
                <div className="mb-4">
                  {/* <p className="text-muted mb-2">
                    <strong>What happens next?</strong>
                  </p> */}
                  {/* <ul className="list-unstyled text-muted text-start">
                    <li className="mb-2">
                      <i className="ri-check-line text-success me-2"></i>
                      Your request will be reviewed within 5-7 business days
                    </li>
                    <li className="mb-2">
                      <i className="ri-check-line text-success me-2"></i>
                      You will receive a confirmation email with your request ID
                    </li>
                    <li className="mb-2">
                      <i className="ri-check-line text-success me-2"></i>
                      Updates will be sent to your provided contact information
                    </li>
                  </ul> */}
                </div>
                <Button
                  color="primary"
                  size="lg"
                  onClick={onStartNewForm}
                  className="px-4"
                >
                  <i className="ri-add-line me-2"></i>
                  Submit Another Request
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SuccessMessage;
